import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { validationSchema, initialValues } from "./formCraneConfig.js";

import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../components/panel/panel";

import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Select from "react-select";
import Swal from "sweetalert2";
import axiosClient from "../../../../config/axios.js";
import FormCrane from "./formCrane.js";
import {
  findPermissionTypesByCoincidence,
  findAutotransportConfigByCoincidence,
} from "../../../../services/CartaPorteService.js";

function NewGrua() {
  const navigate = useNavigate();
  const [craneTypes, setCraneTypes] = useState([]);
  const [insurers, setInsurers] = useState([]);

  useEffect(() => {
    axiosClient
      .get(`/craneTypes/datatable`, {
        params: {
          start: 0,
          length: 10,
          search: "",
          sort: "crane_type_name",
          dir: "asc",
        },
      })
      .then((response) => {
        const transformedOptions = response.data.data.map((item) => ({
          value: item.id,
          label: item.crane_type_name,
        }));
        setCraneTypes(transformedOptions);
      });

    axiosClient.get(`/insurers/all`).then((response) => {
      const transformed = response.data.data.map((item) => ({
        value: item.id,
        label: item.insurance_name,
      }));
      setInsurers(transformed);
    });
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: validationSchema,
    initialValues: initialValues,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);

      const payload = {
        crane_type_ids: values.crane_type_id.map((item) => item.value),
        crane_number: values.crane_number.trim(),
        plate: values.plate.trim(),
        description: values.description.trim(),
        year: Number(values.year),
        capacity: Number(values.capacity),
        serial_number: values.serial_number.trim(),
        vehicular_config: values.vehicular_config?.id || null,
        vehicular_config_description:
          values.vehicular_config?.descripcion || null,
        gross_vehicle_weight: values.gross_vehicle_weight.trim(),
        insurance_id: Number(values.insurance_id),
        civil_liability_policy: values.civil_liability_policy.trim(),
        sct_permit: values.sct_permit?.id || null,
        sct_permit_number: values.sct_permit_number.trim(),
      };

      axiosClient
        .post("/cranes/save", payload)
        .then(() => {
          Swal.fire({
            title: "Registro exitoso.",
            text: "Se ha registrado la nueva Grúa",
            icon: "success",
            confirmButtonText: "Cerrar",
          });
          navigate("/catalogs/cranes");
        })
        .catch((err) => {
          let message = err.response?.data?.message || "Error inesperado";
          Swal.fire({
            title: "Ups!",
            text: message,
            icon: "error",
            confirmButtonText: "Cerrar",
          });
        })
        .finally(() => setSubmitting(false));
    },
  });

  const {
    handleSubmit,
    handleChange,
    setFieldValue,
    setFieldTouched,
    values,
    errors,
    touched,
    isSubmitting,
  } = formik;

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item">Configuración</li>
            <li className="breadcrumb-item">
              <Link to="/catalogs/ubicaciones">Grúas</Link>
            </li>
            <li className="breadcrumb-item active">Nueva Grúa</li>
          </ol>
          <h1 className="page-header mb-0">Registro de nueva Grúa</h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Registro de nueva Grúa</PanelHeader>
            <PanelBody>
              <Form noValidate onSubmit={handleSubmit}>
                <FormCrane
                  formik={formik}
                  craneTypes={craneTypes}
                  insurers={insurers}
                  findPermissionTypesByCoincidence={
                    findPermissionTypesByCoincidence
                  }
                  findAutotransportConfigByCoincidence={
                    findAutotransportConfigByCoincidence
                  }
                />

                <Row className="mb-3">
                  <Col md="12">
                    <Button type="submit" disabled={isSubmitting}>
                      Guardar Grúa
                    </Button>{" "}
                    <Link to={"/catalogs/cranes"} className="btn btn-info">
                      Cancelar
                    </Link>
                  </Col>
                </Row>
              </Form>
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
}

export default NewGrua;
